<template>
    <input
        v-if="
            filter.current_shortcut_key != 'begin_at' &&
            filter.current_shortcut_key != 'end_at' &&
            filter.current_shortcut_key != 'created_duration'
        "
        @keypress.enter="$parent.$parent.$parent.driver_commission_reports_filter()"
        v-model="filter.columns[filter.current_shortcut_key]"
        :placeholder="$t('ui.general.search__key', {
            key: $t('ui.pages.driver_commission_reports.filter.'+filter.current_shortcut_key)
        })"
        type="text"
    >

    <!--
    * ========================================================================
    * = 自行定義
    * ========================================================================
    -->
    <DatePicker
        v-else-if="filter.current_shortcut_key == 'created_duration'"
        v-model="filter.columns.created_duration"
        style="min-width: 200px;width:100%;"
        type="daterange"
        format="YYYY-MM-DD"
        key="created_duration">
    </DatePicker>
    <DatePicker
        v-else-if="filter.current_shortcut_key == 'begin_at'"
        v-model="filter.columns.begin_at"
        style="min-width: 200px;width:100%;"
        type="datetime"
        key="begin_at">
    </DatePicker>
    <DatePicker
        v-else-if="filter.current_shortcut_key == 'end_at'"
        v-model="filter.columns.end_at"
        style="min-width: 200px;width:100%;"
        type="datetime"
        key="end_at">
    </DatePicker>
    <!-- <el-date-picker
        v-else-if="filter.current_shortcut_key == 'begin_at'"
        v-model="filter.columns.begin_at"
        class="right_radius"
        type="datetime"
        :placeholder="$t('ui.el.datepicker.selectDateTime')">
    </el-date-picker>
    <el-date-picker
        v-else-if="filter.current_shortcut_key == 'end_at'"
        v-model="filter.columns.end_at"
        class="right_radius"
        type="datetime"
        :placeholder="$t('ui.el.datepicker.selectDateTime')">
    </el-date-picker> -->
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    name: "DriverCommissionReportsFilterHeaderInputs",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.driver_commission_reports_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        DatePicker
    }
}
</script>
